import React from "react";

const SchemaUrology = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "Who is the best urologist in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "HDNA Aarogyam Hospital houses experienced and skilled urology specialists known for their advanced treatment approach, minimally invasive techniques, and patient-focused care."
                }
            },
            {
                "@type": "Question",
                "name": "What is the cost of kidney stone treatment in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The cost depends on the size, location, and type of procedure required such as URS, PCNL, or laser lithotripsy. We provide transparent pricing after proper medical evaluation."
                }
            },
            {
                "@type": "Question",
                "name": "Are minimally invasive urology surgeries safe?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, minimally invasive urology procedures are safe, effective, and offer faster recovery with less pain and shorter hospital stay when performed by experienced surgeons."
                }
            },
            {
                "@type": "Question",
                "name": "When should I consult a urologist?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You should consult a urologist if you experience symptoms such as blood in urine, severe lower abdominal pain, frequent urination, difficulty passing urine, urinary leakage, or recurrent UTIs."
                }
            },
            {
                "@type": "Question",
                "name": "What types of kidney stone treatments are available at HDNA Aarogyam Hospital?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We offer advanced treatments including laser stone removal, ureteroscopy URS, PCNL, and other minimally invasive procedures based on the patient’s condition."
                }
            },
            {
                "@type": "Question",
                "name": "Do you provide treatment for enlarged prostate BPH?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we provide medical and minimally invasive surgical treatment for enlarged prostate BPH, along with prostate cancer screening and advanced diagnostic evaluation."
                }
            },
            {
                "@type": "Question",
                "name": "Can recurrent urinary tract infections UTIs be permanently treated?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, our specialists identify the underlying cause of recurrent UTIs and provide targeted treatment along with preventive care and lifestyle guidance to reduce recurrence."
                }
            },
            {
                "@type": "Question",
                "name": "Do you treat male infertility and sexual health problems?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, our urology department offers confidential evaluation and treatment for male infertility, erectile dysfunction, and other reproductive health concerns."
                }
            },
            {
                "@type": "Question",
                "name": "Is pediatric urology treatment available?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we provide specialized care for congenital and acquired urinary disorders in children with a patient-friendly and compassionate approach."
                }
            },
            {
                "@type": "Question",
                "name": "Does the hospital provide emergency urology services in Patna?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, HDNA Aarogyam Hospital offers 24/7 emergency urology care for conditions such as severe kidney pain, urinary retention, trauma, or acute infections."
                }
            }
        ]
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
    );
};

export default SchemaUrology;
